var lx = lx || {};
/* Created on 11.10.2019 by Davor */
lx.load = {
    spinner$: null,
    cnt: 0,
    add: function (pUrl, pOverlay) {
        // TODO uniform loading and check count
        if (pUrl) {
            //$("body").append('<div class="lxLoading"></div>');
            $("body").append('<div class="lxLoadingBar"><div class="lxLoadingProgress"></div></div>');
            setTimeout(function () {
                lx.nav.redirect(pUrl);
            }, 1);
        } else if (pOverlay) {
            $("body").append('<div class="lxLoading"></div>');
            //$("body").append('<div class="lxLoadingBar"><div class="lxLoadingProgress"></div></div>');
            if (lx.load.cnt == 0) lx.load.spinner$ = apex.util.showSpinner();
        } else {
            //$("body").append('<div class="lxLoadingBar"><div class="lxLoadingProgress"></div></div>');
            if (lx.load.cnt == 0) lx.load.spinner$ = apex.util.showSpinner();
        }
        lx.load.cnt++;
        console.log('load cnt: '+ lx.load.cnt);
    },
    remove: function () {
        lx.load.cnt--;
        if (lx.load.cnt <= 0) {
            $(".lxLoading").remove();
            //$(".lxLoadingBar").remove();
            lx.load.spinner$.remove();
            console.log('load remove');
        }
    }
};

lx.dec = function (pDec) {
	if (pDec==''){
		return '.';
	}
	else if (typeof pDec==='undefined'){
		return '.';
	}
	else {
		return pDec;
	}
};

lx.tran = lx.tran || {};
/*lx.tran.get = function (pCode){
    return apex.lang.getMessage(pCode);
}*/

lx.tran.get = function (pCode) {
    // Check if apex.lang.getMessage is loaded
    if (typeof apex.lang.getMessage === 'function') {
        return apex.lang.getMessage(pCode);
    } else {
        // Handle the case where apex.lang.getMessage is not loaded
        console.error("apex.lang.getMessage is not loaded.");
        return null; // Or some default value error handling
	}
};

lx.util = lx.util || {};

lx.util.stripNonNumeric = function (str, replaceDecimal, pDec) {
    var decimal = lx.dec(pDec);//$v('P0_DECIMAL');
	//alert('decimal='+decimal);
    str += '';
    var rgx = new RegExp("\\d|\\" + decimal + "|-");
    var out = '';
    for (var i = 0; i < str.length; i++) {
        if (rgx.test(str.charAt(i))) {
            if (!((str.charAt(i) == decimal && out.indexOf(decimal) != -1) ||
                (str.charAt(i) == '-' && out.length != 0))) {
                out += str.charAt(i);
            }
        }
    }
    if (replaceDecimal) {
        return out.replace(decimal, ".");
    } else {
        return out;
    }
};

lx.util.roundPrice = function (pNum) {
    return (Math.round(pNum * 100) / 100);
};

lx.util.strToNumber = function (pStr,pDec) {
    var rawValue = pStr;
    rawValue = lx.util.stripNonNumeric(rawValue, true, lx.dec(pDec));
    let val = parseFloat(rawValue);
    return (isNaN(val) ? 0 : val );
};

lx.util.numToString = function (pNum, pFixed) {
    var rawValue;
    if (pFixed) rawValue = pNum.toFixed(2).toString();
    else rawValue = pNum.toString();
    var decimal = apex.locale.getDecimalSeparator();
    return rawValue.replace(".", decimal);
};//apex.locale.getGroupSeparator()

lx.util.strToNumberF = function (str) {
  const groupSep = apex.locale.getGroupSeparator();
  const decimalSep = apex.locale.getDecimalSeparator();

  if (!str || typeof str !== 'string') return 0;

  const normalized = str
    .replace(new RegExp('\\' + groupSep, 'g'), '')
    .replace(new RegExp('\\' + decimalSep), '.');

  return parseFloat(normalized);
}

lx.util.numToStringF = function (num) {
  const groupSep = apex.locale.getGroupSeparator();
  const decimalSep = apex.locale.getDecimalSeparator();

  if (typeof num !== 'number') return '';

  const parts = num
    .toFixed(2)
    .split('.');

  let intPart = parts[0];
  let decPart = parts[1];

  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);

  return intPart + decimalSep + decPart;
}

lx.util.vn = function (pItem,pDec) {
	//alert("q="+lx.dec(pDec)); 
    var rawValue = $v(pItem);
    if (rawValue == "") {
        return 0;
    } else {
        return lx.util.strToNumber(rawValue, lx.dec(pDec));
    }
};

lx.util.sn = function (pItem, pValue, pSuppress) {
    apex.item(pItem).setValue(lx.util.numToString(pValue), null, pSuppress);
};

lx.util.popup = function (url, w, h) {
	var day = new Date;
	apex.navigation.popup({
		url:    url,
        name:   day.getTime(),
        width:  w,
        height: h});
};

lx.util.loadFile = function (filename, filetype) {
    if (filetype == "js") { //if filename is a external JavaScript file
        var len = $('script').filter(function () {
            return ($(this).attr('src') == filename);
        }).length;

        //if there are no scripts that match, the load it
        if (len === 0) {
            $.getScript(filename);
        }

    } else if (filetype == "css") { //if filename is an external CSS file
        var fileref = document.createElement("link")
        fileref.setAttribute("rel", "stylesheet")
        fileref.setAttribute("type", "text/css")
        fileref.setAttribute("href", filename)
    }
    if (typeof fileref != "undefined")
        document.getElementsByTagName("head")[0].appendChild(fileref)
};

// Temporary solution for legacy apex function 'toolTip_enable'
lx.util.toolTip_enable = function (a, b, c, d, e) {};

/* before was lxnvl function*/
lx.util.nvl = function (pVal, pDef) {
    if (pVal == "" || pVal == null) return pDef;
    return pVal;
};

/* before was getCheckedValuesByName function*/
lx.util.getCheckedValuesByName = function (pName, pSeparator) {
    var lValues = [];
    var lSeparator = lxnvl(pSeparator, ':');
    $("input[name='" + pName + "']:checked").each(function () {
        lValues.push($(this).val());
    });
    return lValues.join(lSeparator);
};

// use cases: stringToDate("17/9/2014","dd/MM/yyyy","/"); stringToDate("9/17/2014","mm/dd/yyyy","/") stringToDate("9-17-2014","mm-dd-yyyy","-");
/* before was stringToDate function*/
lx.util.stringToDate = function (_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
};

/* before was checkDateFormat function*/
lx.util.checkDateFormat = function (value, userFormat) {
    var userFormat = userFormat || 'dd/mm/yyyy', // default format

        delimiter = /[^dmy]/.exec(userFormat)[0],
        theFormat = userFormat.split(delimiter),
        theDate = value.split(delimiter),

        isDate = function (date, format) {
            var d, m, y
            for (var i = 0, len = format.length; i < len; i++) {
                if (/d/.test(format[i])) d = date[i]
                if (/m/.test(format[i])) m = date[i]
                if (/y/.test(format[i])) y = date[i]
            }
            return (
                m > 0 && m < 13 &&
                y && y.length === 4 &&
                d > 0 && d <= (new Date(y, m, 0)).getDate()
            )
        }

    return isDate(theDate, theFormat);

};

lx.util.escapeHTML = function (pValue) {
    return apex.util.escapeHTML(pValue);
};

lx.util.stripHTML = function (pValue) {
    return apex.util.stripHTML(pValue);
};

lx.hideSideMenu = function (){
    if ($('#t_Button_navControl').attr('aria-expanded') === "true") {
        $('#t_Button_navControl').click();
       }
};

lx.showSideMenu = function (){
    if ($('#t_Button_navControl').attr('aria-expanded') === "false" && window.innerWidth > 992) {
        $('#t_Button_navControl').click();
       }
};

lx.copyToClipboard = function (text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
	lx.info.success("URL is copied to clipboard.");
  } catch (err) {
	lx.info.error("URL is NOT copied to clipboard.");
  }
  document.body.removeChild(textArea);
}

// TODO find a better way
var translation = {delete_message:"Are you sure you want to delete this?",leave_no_save:"Are you sure you want to leave this page without saving?",date_format:"mm/dd/yy",time_format:"hh:mm tt"};
var stripNonNumeric = lx.util.stripNonNumeric;
var roundPrice = lx.util.roundPrice;
var strToNumber = lx.util.strToNumber;
var numToString = lx.util.numToString;
var strToNumberF = lx.util.strToNumberF;
var numToStringF = lx.util.numToStringF;
var vn = lx.util.vn;
var sn = lx.util.sn;
var toolTip_enable = lx.util.toolTip_enable;
var loadFile = lx.util.loadFile;
var lxnvl = lx.util.nvl;
var getCheckedValuesByName = lx.util.getCheckedValuesByName;
var stringToDate = lx.util.stringToDate;
var checkDateFormat = lx.util.checkDateFormat;
